import { FC } from "react";
import { Stack, Typography } from "@mui/material";
import { background, text as textColor, primary } from "@/theme/colors";
import { rounded } from "@/theme/variables";

type Props = {
  label: string;
  value: number;
  unit: string;
  highlight?: boolean;
};

export const StudyTimeStatItem: FC<Props> = ({ label, value, unit, highlight = false }) => (
  <Stack
    sx={{
      bgcolor: highlight ? primary[900] : background.primary,
      borderRadius: rounded.xs,
      p: 1,
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    {/* Title */}
    <Typography variant="cap12" color={textColor.secondary} textAlign={"center"}>
      {label}
    </Typography>
    {/* Value + Unit */}
    <Stack display="flex" alignItems="flex-end" flexDirection="row">
      <Typography variant="head24Bold" color={primary[500]} align="center">
        {value}
      </Typography>
      <Typography variant="body14Semi" color={textColor.secondary} align="center">
        {unit}
      </Typography>
    </Stack>
  </Stack>
);
